import * as React from 'react'

import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin'

import { useEditor } from '../useEditor'
import { validateUrl } from '../utils/url'

export function LinkPlugin() {
  const editor = useEditor()

  if (!editor.isEditable()) {
    return null
  }

  return <LexicalLinkPlugin validateUrl={validateUrl} />
}
